import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, map, mergeMap, withLatestFrom } from "rxjs/operators";
import { LoadingService } from "../../loading/loading.service";
import { MatDialog } from "@angular/material/dialog";
import { AppState, appStore } from "../../app.state";
import { IBusquedaRequest } from "../../interfaces/busqueda";
import { BusquedaService } from "../../services/busqueda/busqueda.service";
import { selectTemasUsuario } from "../usuario/selector";
import { cargaUsuario } from "../usuario/actions";
import { buscarEntradaFail } from "../busqueda/actions";
import { LoadCatalogosService } from "../../services/catalogos/load-catalogos/load-catalogos.service";
import { cargaCatalogos } from "./actions";
import { mCatalogos } from "../../entrada/entrada.interface";

@Injectable()
export class CatalogosEffects {
  constructor(
    private actions$: Actions,
    private busquedaService: BusquedaService,
    private store: Store<AppState>,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    public loadCatalogosService: LoadCatalogosService
  ) {}

  loadCatalogos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cargaUsuario),
      withLatestFrom(this.store.select(selectTemasUsuario)),
      mergeMap(([actions, user]) => {
        return this.loadCatalogosService.cargaCatalogos().pipe(
          map((oCatalogos) => {
            return cargaCatalogos({ oCatalogos });
          }),
          catchError((error) => {
            return of(cargaCatalogos({ oCatalogos: mCatalogos })); // Manejo de errores
          })
        );
      }),
      catchError((error) => {
        console.error("Error en el efecto:", error);
        return of(buscarEntradaFail());
      })
    )
  );
}
